import styled from 'styled-components';
import {LoadingDots} from './LoadingState';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 0;
`;

export const ListSpinner = () => {
  return (
    <Container>
      <LoadingDots size={7} />
    </Container>
  );
};
